import React from "react";
import { useRecordContext } from "react-admin";

import { parseTierPriceStringToJSON, validateTierPrice } from "./TierPrice";
import { Tooltip } from "@mui/material";

const tpToString = ({ minQuantity, price }) => `${minQuantity}pcs for ${price}`;

const TieredPricesField = (props) => {
  const { ellipsis = false, source = "" } = props;
  const record = useRecordContext();
  const tieredPrices = record[source] || "";
  if (tieredPrices) {
    const isValid = validateTierPrice(tieredPrices);
    if (isValid) {
      const prices = parseTierPriceStringToJSON(tieredPrices);
      const priceStr =
        prices.length > 0 ? [prices[0]].map(tpToString).join("") : "";
      const suffix = prices.length > 1 ? `, ...` : "";
      const tipStr =
        prices.length > 0 ? (
          <span>
            {prices.map(tpToString).map((str, idx) => (
              <div key={idx}>{str}</div>
            ))}
          </span>
        ) : (
          ""
        );
      if (ellipsis) {
        return (
          <Tooltip title={tipStr}>
            <span>{`${priceStr}${suffix}`}</span>
          </Tooltip>
        );
      } else {
        return <span>{tipStr}</span>;
      }
    }
  }
  return <span></span>;
};

export default TieredPricesField;
